import { create } from 'zustand';

export const useUIStore = create((set) => ({
  authTabIndex: 0,
  authDrafts: {
    guid: '',
    email: '',
    password: '',
  },
  counselorDashboard: {
    scopeKey: '',
    search: '',
    page: 1,
    filter: 'all',
    sort: 'recent',
    viewAll: false,
    cohortId: '',
    addedAfter: '',
    addedBefore: '',
  },
  setAuthTabIndex: (authTabIndex) => set({ authTabIndex }),
  setAuthDraft: (key, value) =>
    set((state) => ({
      authDrafts: {
        ...state.authDrafts,
        [key]: value,
      },
    })),
  clearAuthDrafts: () =>
    set({
      authDrafts: {
        guid: '',
        email: '',
        password: '',
      },
    }),
  setCounselorSearch: (search) =>
    set((state) => ({
      counselorDashboard: {
        ...state.counselorDashboard,
        search,
      },
    })),
  setCounselorPage: (page) =>
    set((state) => ({
      counselorDashboard: {
        ...state.counselorDashboard,
        page,
      },
    })),
}));
